//
import { InputSelectIcon } from './CustomIcons';

// ----------------------------------------------------------------------

export default function Select() {
  return {
    MuiSelect: {
      styleOverrides: {
        // If you want to style the menu as well, you can override MuiSelectMenu:
        menu: {
          background: "hsla(0, 0%, 10%, .8) !important", // darker or more opaque
          backdropFilter: "blur(20px) !important", // stronger blur
          WebkitBackdropFilter: "blur(20px) !important", // Safari
        },
      },
    },

  };
}
